import React from 'react';
import { Columns } from '@components/Columns';
import {
  StreamlineCommunicationWrapper,
  StreamlineCommunicationTextPairing,
  BgImage,
  TextPairBox,
  StyledTextColumn,
} from './StreamlineCommunication.styles';
import ReactHtmlParser from 'react-html-parser';
import { GetStartedButton } from '@components/GetStartedButton/GetStartedButton';
import { Box } from 'theme-ui';
import { Flex } from '@components/Flex';
import { useTranslation } from 'react-i18next';

export const StreamlineCommunicationSection: React.FC = () => {
  const { t } = useTranslation('hotelRoomBlocks');
  const streamlineCommunicationSectionData = t('streamlinedCommunicationSection');

  return (
    <StreamlineCommunicationWrapper as="section" id="Streamline_Communication">
      <TextPairBox>
        <StyledTextColumn centered>
          <Columns.Column width="full">
            <StreamlineCommunicationTextPairing
              alignment="center"
              eyebrow={streamlineCommunicationSectionData.eyeBrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant="sectionEyeBrow20"
              eyebrowTagName="h2"
              title={ReactHtmlParser(streamlineCommunicationSectionData.title)}
              titleVariant="hed40"
              titleColor="humanaDark6"
              titleTagName="h2"
              body={streamlineCommunicationSectionData.content}
              bodyVariant="dek24"
              bodyColor="neutra5"
              bodyTagName="p"
            />
            <Box style={{ textAlign: 'center' }} marginTop={[30, 50]} marginBottom={24}>
              <GetStartedButton id="hotelRoomBlocksStreamlineCommunicationGetStartedBtn" page={'hotel-room-blocks'} variant="primary">
                {streamlineCommunicationSectionData.buttonStarted}
              </GetStartedButton>
            </Box>
          </Columns.Column>
        </StyledTextColumn>
      </TextPairBox>
      <Flex justifyContent="center" alignItems="center">
        <BgImage src={streamlineCommunicationSectionData.bgImage} />
      </Flex>
    </StreamlineCommunicationWrapper>
  );
};
